<template>
  <div class="stepOut">
    <div class="stepItem">
      <p :class="stepInfo.status >= 1 ? 'blue' : 'gray'">售后申请</p>
      <p class="time">{{ stepInfo.applyTime }}</p>
      <div class="stepItem_xian" v-if="stepInfo.status == 7">
        <div v-for="(item, index) in 8">
          <div class="dot2"></div>
        </div>
        <div v-for="(item, index) in 7">
          <div class="dot1"></div>
        </div>
      </div>
      <div v-else class="stepItem_xian">
        <div v-for="(item, index) in 15">
          <div class="dot"></div>
        </div>
      </div>
      <div class="dots" v-if="stepInfo.status == 7"></div>
      <div class="info" v-if="stepInfo.status == 7">申请已取消</div>
    </div>
    <div class="stepItem shenheStatus">
      <p
        :class="
          stepInfo.status >= 1 && stepInfo.status != 7 && stepInfo.status != 1
            ? 'blue'
            : 'gray'
        "
      >
        审核申请
      </p>
      <p class="time">{{ stepInfo.auditTime }}</p>
      <div v-if="stepInfo.status == 2" class="stepItem_xian">
        <div v-for="(item, index) in 8">
          <div class="dot2"></div>
        </div>
        <div v-for="(item, index) in 7">
          <div class="dot1"></div>
        </div>
      </div>
      <div
        v-if="stepInfo.status == 7 || stepInfo.status == 1"
        class="stepItem_xian"
      >
        <div v-for="(item, index) in 15">
          <div class="dot1"></div>
        </div>
      </div>
      <div v-if="stepInfo.status == 8" class="stepItem_xian">
        <div v-for="(item, index) in 15">
          <div class="dot"></div>
        </div>
      </div>
      <div class="dots" v-if="stepInfo.status == 2"></div>
      <div class="info" v-if="stepInfo.status == 2">申请已驳回</div>
      <div v-if="statustype == 3" class="close"></div>
      <!--  -->
    </div>
    <div class="stepItem">
      <p :class="stepInfo.status == 8 ? 'blue' : 'gray'">售后完成</p>
      <p class="time">{{ stepInfo.completeTime }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'steps',
  props: {
    // 传递步骤参数
    stepInfo: {
      type: Object,
      default: function () {
        return {
          list: []
        }
      }
    },
    statustype: {
      type: String,
      default: null
    }
  },
  methods: {
    examine () {
      this.$parent.examine()
    }
  }

}
</script>

<style lang="scss" scoped>
.stepOut {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 20px;
  .stepItem {
    width: 208px;
    height: 80px;
    background: #e9ecfe;
    opacity: 1;
    border-radius: 40px;
    text-align: center;
    position: relative;
    box-sizing: border-box;
    padding-top: 15px;
    .stepItem_xian {
      position: absolute;
      left: 110%;
      top: 40px;
      width: 50%;
      // height: 0px;
      // border: 1px dashed #cccccc;
      display: flex;
      justify-content: space-between;
    }
    .dot {
      width: 4px;
      height: 4px;
      background: #2d46ee !important;
      border-radius: 50%;
      opacity: 1;
      margin-right: 16px;
    }
    .dot1 {
      width: 4px;
      height: 4px;
      background: #e9ecfe !important;
      border-radius: 50%;
      opacity: 1;
      margin-right: 16px;
    }
    .dot2 {
      width: 4px;
      height: 4px;
      background: #f63c56 !important;
      border-radius: 50%;
      opacity: 1;
      margin-right: 16px;
    }
    .dots {
      position: absolute;
      left: 178%;
      top: 70px;
      width: 4px;
      height: 4px;
      background: #f63c56 !important;
      border-radius: 50%;
      opacity: 1;
    }
    .info {
      position: absolute;
      left: 158%;
      top: 80px;
      width: 80px;
      height: 21px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 21px;
      color: #f63c56;
      opacity: 1;
    }
    .lineAction {
      // border: 1px dashed #4c81eb;
    }
    .blue {
      width: 112px;
      height: 36px;
      line-height: 36px;
      background: #2d46ee;
      opacity: 1;
      border-radius: 35px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-left: 48px;
    }
    .gray {
      width: 112px;
      height: 36px;
      line-height: 36px;
      background: #ffffff;
      border-radius: 35px;
      font-size: 16px;
      font-weight: 400;
      color: #c0c0cc;
      margin-left: 48px;
    }
    .time {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 0px;
      color: #2d46ee;
      margin-top: 10px;
    }
  }
  .shenheStatus {
    position: relative;
    .close {
      position: absolute;
      left: 77%;
      top: 54px;
      width: 50%;
      height: 0px;
      border: 1px dashed red;
      &:before {
        width: 8px;
        height: 8px;
        background: red;
        border-radius: 50%;
        content: "";
        color: red;
        position: absolute;
        border: 3px solid #f5d3d9;
        left: 45%;
        top: -7px;
      }
      &:after {
        width: 100%;
        content: "审核不通过";
        color: red;
        position: absolute;
        left: 0%;
        top: -39px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .stepOut {
    display: flex;
    justify-content: center;
    .stepItem {
      width: 16%;
      height: 140px;
      text-align: center;
      position: relative;
      box-sizing: border-box;
      padding-top: 15px;
      .stepItem_img {
        width: 48px !important;
        height: 48px !important;
      }
      .stepItem_xian {
        position: absolute;
        left: 77%;
        top: 54px;
        width: 50%;
        height: 0px;
        border: 1px dashed #cccccc;
      }
      .lineAction {
        border: 1px dashed #4c81eb;
      }
      .blue {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
      }
      .gray {
        font-size: 14px;
        font-weight: 400;
        color: #cccccc;
      }
      .time {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
      }
    }
    .shenheStatus {
      position: relative;
      .close {
        position: absolute;
        left: 77%;
        top: 54px;
        width: 50%;
        height: 0px;
        border: 1px dashed red;
        &:before {
          width: 8px;
          height: 8px;
          background: red;
          border-radius: 50%;
          content: "";
          color: red;
          position: absolute;
          border: 3px solid #f5d3d9;
          left: 45%;
          top: -7px;
        }
        &:after {
          width: 100%;
          content: "审核不通过";
          color: red;
          position: absolute;
          left: 0%;
          top: -39px;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
